





























































































































































import {Component, Vue} from "vue-property-decorator";
import {TimeAssistant} from "@/entity/TimeAssistant";
import {TimeAssistantDto} from "@/dto/TimeAssistantDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Friend} from "@/entity/Friend";
import {TimeAssistantAttachment} from "@/entity/TimeAssistantAttachment";
import {TimeAssistantAttachmentDto} from "@/dto/TimeAssistantAttachmentDto";
import {TimeAssistantCollaboratorDto} from "@/dto/TimeAssistantCollaboratorDto";
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";
import {TimeAssistantFeedback} from "@/entity/TimeAssistantFeedback";
import {TimeAssistantFeedbackDto} from "@/dto/TimeAssistantFeedbackDto";

@Component({
  components: {},
})

export default class TimeAssistantDetails extends Vue {
  id = this.$route.params.id;
  timeAssistant = new TimeAssistant();
  su = SecurityUtils;
  timeAssistants: TimeAssistant[] = [];
  timeAssistantFriends: Friend[] = [];
  timeAssistantAttachments: TimeAssistantAttachment[] = [];
  timeAssistantCreator = new Friend();
  timeAssistantCollaborators: TimeAssistantCollaborator[] = [];
  timeAssistantCollaborator = new TimeAssistantCollaborator();
  timeAssistantCollaborator1 = new TimeAssistantCollaborator();
  respond = 0;
  timeAssistantFeedbacks: TimeAssistantFeedback[] = [];
  timeAssistantFeedback = new TimeAssistantFeedback();

  async finishTimeAssistant() {
    this.timeAssistantCollaborator1.isFinish = true;
    this.timeAssistantCollaborator1.finishTime = TimeAssistantDetails.formatDate(Date.parse(new Date().toString()));
    await TimeAssistantCollaboratorDto.save(this.timeAssistantCollaborator1);
    this.$router.push({name: 'allTimeAssistant'});
  }

  async del(t: TimeAssistantFeedback) {
    if (t.username == this.su.getLoginUser().username) {
      await TimeAssistantFeedbackDto.delete(t.id as number);
      await this.findAllTimeAssistantFeedbacks();
    } else {
      const nf = this.$q.notify({message: '只能删除自己的反馈', timeout: 1000});
    }
  }

  async accept(isRespond: boolean) {
    const timeAssistantCollaborator2 = new TimeAssistantCollaborator();
    timeAssistantCollaborator2.timeAssistantId = this.timeAssistant.id as number;
    timeAssistantCollaborator2.username = this.su.getLoginUser().username;
    const timeAssistantCollaborators1 = await TimeAssistantCollaboratorDto.findAll(timeAssistantCollaborator2);
    const timeAssistantCollaborator = timeAssistantCollaborators1[0];
    timeAssistantCollaborator.isRespond = isRespond;
    await TimeAssistantCollaboratorDto.save(timeAssistantCollaborator);
    await this.$router.push({name: 'refresh'});
    const nf = this.$q.notify({message: '已响应', timeout: 1000, color: 'green'});
  }

  radio() {
    this.$q.dialog({
      title: '请选择拒绝理由',
      html: true,
      options: {
        type: 'radio',
        model: 'opt1',
        // isValid: (val: string) => val === 'opt2',
        // inline: true
        items: [
          {label: '时间冲突，无法参加', value: '时间冲突，无法参加'},
          {label: '请假了，无法参加', value: '请假了，无法参加'},
          {label: '出差了，无法参加', value: '出差了，无法参加'},
          {label: '其他原因，无法参加', value: '其他原因，无法参加'},
          {label: '手动输入回复', value: '手动输入回复', color: 'secondary'},
        ]
      },
      cancel: true,
      persistent: true
    }).onOk(async (data: any) => {
      if (data == '手动输入回复') {
        await this.accept(false);
        // await this.findAllTimeAssistantFeedbacks();
        await this.$router.push({name: 'feedback', params: {id: this.timeAssistant.id as unknown as string}});
      } else {
        this.timeAssistantFeedback.timeAssistantId = this.id as unknown as number;
        this.timeAssistantFeedback.username = this.su.getLoginUser().username;
        this.timeAssistantFeedback.name = this.su.getLoginUser().name;
        this.timeAssistantFeedback.url = this.su.getLoginUser().avatarUrl;
        this.timeAssistantFeedback.feedback = data;
        await TimeAssistantFeedbackDto.save(this.timeAssistantFeedback);
        this.timeAssistantFeedback = new TimeAssistantFeedback();
        await this.accept(false);
        // await this.findAllTimeAssistantFeedbacks();
        await this.$router.push({name: 'refresh'});//
      }
      // console.log('>>>> OK, received', data)
    })
  }

  static formatDate(timeStamp: number) {
    //三目运算符
    const Dates = new Date(timeStamp);
    //年份
    const Year: number = Dates.getFullYear();
    //月份下标是0-11
    const Months: any = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1);
    //具体的天数
    const Day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate();
    //小时
    const Hours = Dates.getHours() < 10 ? '0' + Dates.getHours() : Dates.getHours();
    //分钟
    const Minutes = Dates.getMinutes() < 10 ? '0' + Dates.getMinutes() : Dates.getMinutes();
    //秒
    const Seconds = Dates.getSeconds() < 10 ? '0' + Dates.getSeconds() : Dates.getSeconds();
    //返回数据格式
    return Year + '/' + Months + '/' + Day + " " + Hours + ":" + Minutes;
  }

  async findAllTimeAssistantFeedbacks() {
    const timeAssistantFeedback1 = new TimeAssistantFeedback();
    timeAssistantFeedback1.timeAssistantId = this.timeAssistant.id as number;
    timeAssistantFeedback1.time = '';
    this.timeAssistantFeedbacks = await TimeAssistantFeedbackDto.findAll(timeAssistantFeedback1);
  }

  async findAllTimeAssistantAttachments() {
    const timeAssistantAttachment = new TimeAssistantAttachment();
    timeAssistantAttachment.timeAssistantId = this.timeAssistant.id as number;
    this.timeAssistantAttachments = await TimeAssistantAttachmentDto.findAll(timeAssistantAttachment);//全部附件
  }

  async mounted() {
    this.timeAssistant = await TimeAssistantDto.findById(this.id as unknown as number);
    const timeAssistantCollaborator1 = new TimeAssistantCollaborator();
    timeAssistantCollaborator1.timeAssistantId = this.timeAssistant.id as number;
    const timeAssistantCollaborators = await TimeAssistantCollaboratorDto.findAll(timeAssistantCollaborator1);//日程全部协作人
    timeAssistantCollaborators.forEach(value => {
      if (value.username == this.timeAssistant.username) {
        this.timeAssistantCollaborator = value;//日程创建者
      }
      if (value.username != this.su.getLoginUser().username) {
        this.timeAssistantCollaborators.push(value);
        if (value.isRespond)
          this.respond++;
      } else {
        // this.timeAssistant.timeAssistantCollaborators = value;
        this.timeAssistantCollaborator1 = value;
      }
    });
    await this.findAllTimeAssistantAttachments();
    await this.findAllTimeAssistantFeedbacks();
  }
}
